import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const AnagraficaAtecoSection = ({
  currentAnagrafica,
  baseAtecoList,
  isCessato,
  isNotLastVersion,
  onChange,
}) => {
  return (
    <Stack>
      <Divider variant="standard" sx={{ pt: 2 }} />
      <ExtendedTypography variant="titleSmall" color="primary.main" sx={{ pt: 1 }}>
        Ateco
      </ExtendedTypography>
      <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
        <Autocomplete
          id="ddlAtecoCodes"
          size="small"
          fullWidth
          sx={{ width: "15%" }}
          disableClearable={false}
          options={baseAtecoList}
          value={
            baseAtecoList.find(
              (item) => item.atecoCode === currentAnagrafica.atecoCode
            ) ?? null
          }
          filterOptions={(options, state) => {
            let newOptions = [];
            let toSearch = state.inputValue;
            options.forEach((element) => {
              if (element.atecoCode.startsWith(toSearch)) newOptions.push(element);
            });
            return newOptions;
          }}
          getOptionLabel={(option) => option.atecoCode}
          renderInput={(params) => (
            <TextField {...params} label="Prevalente attività svolta" sx={{ lineHeight: 1 }} />
          )}
          onChange={(event, value) =>
            onChange({ target: { id: "ddlAtecoCodes" } }, value)
          }
          clearOnEscape
          readOnly={isCessato || isNotLastVersion}
        />
        <Autocomplete
          id="ddlAtecoCodesDesc"
          size="small"
          fullWidth
          sx={{ width: "85%" }}
          disableClearable={false}
          options={baseAtecoList}
          value={
            baseAtecoList.find(
              (item) => item.atecoCode === currentAnagrafica.atecoCode
            ) ?? null
          }
          getOptionLabel={(option) => option.atecoTitle}
          renderInput={(params) => (
            <TextField {...params} label="Descrizione dell'attività" sx={{ lineHeight: 1 }} />
          )}
          onChange={(event, value) =>
            onChange({ target: { id: "ddlAtecoCodesDesc" } }, value)
          }
          clearOnEscape
          readOnly={isCessato || isNotLastVersion}
        />
      </Stack>
    </Stack>
  );
};
